import { render, staticRenderFns } from "./addComponent.vue?vue&type=template&id=031576f3&scoped=true&"
import script from "./addComponent.vue?vue&type=script&lang=js&"
export * from "./addComponent.vue?vue&type=script&lang=js&"
import style0 from "./addComponent.vue?vue&type=style&index=0&id=031576f3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031576f3",
  null
  
)

export default component.exports